import { useEffect, useState } from 'react';
import { generalStore } from '../stores/GeneralStore';
import { getRevenuePool } from '../api/stoApi';
import { TRevenuePool } from '@brickwise/asset-validation';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../router/Routes';
import { apiErrorHandling } from '../api/apierrorhandling';
import { useTranslation } from 'react-i18next';

export const useRevenuePool = (id: string, reload: boolean) => {
  const { t } = useTranslation();
  const [revenuePool, setRevenuePool] = useState<TRevenuePool | null>(null);
  const navigate = useNavigate();
  const load = async () => {
    if (!id) return;
    try {
      generalStore.setIsLoading(true);
      const res = (await getRevenuePool(id))?.data;
      setRevenuePool(res.data);
    } catch (err) {
      apiErrorHandling(err, t('revenuePools.errors.loadOne'));
      navigate(Routes.REVENUE_POOLS.ROOT);
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id, reload]);

  return revenuePool;
};
